import React, { useEffect, useRef } from "react";
import { Card } from "react-bootstrap";
import { useGetAccumulatedBarsQuery } from "../../app/features/apiSlice";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Loader from "../../components/Loader";
import Error from "../../components/Error";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useDispatch } from "react-redux";
import { setPageTitle } from "../../app/features/DataSlice";
const AccumulatedBars = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const sessionId = useRef(Date.now()).current;
  const { data, isLoading, isError, error } = useGetAccumulatedBarsQuery({
    sessionId,
  });

  useEffect(() => {
    dispatch(setPageTitle(t(`accumulatedIngots`)));
  });

  if (isLoading) return <Loader />;
  if (isError) return <Error error={error} />;
  return (
    <div className="my-3">
      <Card bg="dark1 text-light">
        <Card.Body>
          <DataTable
            value={data?.data}
            sortMode="multiple"
            paginator
            rows={10}
            rowsPerPageOptions={[10, 25, 50]}
            size={"small"}
            showGridlines
            stripedRows
            removableSort
          >
            <Column sortable field="series" header={t("series")}></Column>
            <Column sortable field="number" header={t("number")}></Column>
            <Column
              sortable
              field="weight_gr"
              header={t("weight")}
              body={(rowData) => `${rowData.weight_gr} gr`}
            ></Column>
            <Column
              sortable
              field="date"
              header={t("date")}
              body={(rowData) => moment(rowData.date).format("DD-MM-YYYY")}
            />
            <Column />
          </DataTable>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AccumulatedBars;
